<template>
  <div class="card-grid-display">
    <v-card
      class="mx-auto agenda-card"
      width="100%"
      v-for="(agendaItem, index) in columnData"
      :key="`template_${index}`"
    >
      <v-card-text>
        <v-row no-gutters>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on"
                class="full-width text-caption font-weight-bold text-center secondary overflow-wrap"> {{ $t('agenda.tipAgenda') }} </span>
            </template>
            <span v-html="$t('agenda.tipforAgenda')"></span>
          </v-tooltip>
        </v-row>
        <v-row no-gutters>
          <span
            class="text--topic overflow-wrap"
            >{{ agendaItem.agendaName }}</span
          >
        </v-row>

        <div class="topic-grid-display">
          <v-row no-gutters>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on"
                  class="mt-3 full-width text-caption font-weight-bold text-center secondary overflow-wrap"> {{ $t('topic') }} </span>
              </template>
              <span v-html="$t('agenda.tipforTopics')"></span>
            </v-tooltip>
            <v-row no-gutters class="mt-2">
              <v-col>
                <span class="text--topic overflow-wrap">{{
                  agendaItem.topicName
                }}</span>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-2">
              <v-col cols="auto">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <a-chip
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      class="minute"
                      small
                      >{{ agendaItem.topicTimeInMins }} {{ $t("Minutes") }}</a-chip
                    >
                  </template>
                  <span>{{ $t("agenda.tipTopicDuration") }}</span>
                </v-tooltip>
              </v-col>
              <v-col
                cols="auto"
                class="pl-2"
                v-if="agendaItem.documents && agendaItem.documents.length > 0"
              >
                <agenda-document-list
                  :documents="agendaItem.documents"
                  :title="agendaItem.topicName"
                >
                </agenda-document-list>
              </v-col>
            </v-row>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import AChip from "../../wrapper-component/AChip.vue";
import AgendaDocumentList from "./AgendaDocumentList.vue";
export default {
  components: { AChip, AgendaDocumentList },
  name: "AgendaViewGridRowTemplate",
  props: {
    column: {
      type: Object,
      default: () => {},
    },
    agendaList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data: {},
      docDialog: [],
    };
  },
  computed: {
    ...mapState({
      agendaListData: (state) => state.agenda.agendaList,
    }),
    columnData() {
      const topics = this.data.topics.filter(
        (t) => t.topicCategory === this.column.id
      );

      const items = topics.map((topic) => {
        const agendaData = this.agendaListData.find(
          (agenda) => agenda.id === topic.agendaId
        );

        if (agendaData) {
          return {
            agendaName: agendaData.agendaName,
            topicId: topic.Id,
            topicName: topic.topicName,
            topicTimeInMins: topic.timeInMinutes,
            documents: topic.documents,
            displayOrder: topic.displayOrder || 0,
          };
        } else {
          return {
            agendaName: "",
            topicId: topic.Id,
            topicName: topic.topicName,
            topicTimeInMins: topic.timeInMinutes,
            documents: topic.documents,
            displayOrder: topic.displayOrder || 0,
          };
        }
      });

      return items.sort((a, b) => a.displayOrder - b.displayOrder);
    },
  },
  methods: {},
};
</script>

<style>
</style>